// extracted by mini-css-extract-plugin
module.exports = {"item":"CheckItem-module--item--aNezB","item__text":"CheckItem-module--item__text--3oItS","checkIconWrap":"CheckItem-module--checkIconWrap--2RzoR"};